module.exports = __webpack_public_path__ + "img/9788970635224.4bac4638.jpg";